import { productGalleryTabsSX } from '@/components/blocks/ProductDetails/styles/productGalleryTabs';
import { Box } from '@mui/material';
import { FC } from 'react';

interface View360Props {
	view360URL: string;
}

export const View360: FC<View360Props> = ({ view360URL }) => (
	<Box id="media360" sx={productGalleryTabsSX.view360Tab}>
		<div id="cora-ar-3d-viewer">
			<iframe id="iframe-cora" frameBorder="0" src={view360URL} width="100%" height="100%"></iframe>
		</div>
	</Box>
);
